module.exports = __webpack_public_path__ + "img/oval-grey.72d6d2dc.svg";